import React from 'react';
import PropTypes from 'prop-types';
import { UncontrolledTooltip } from 'reactstrap';
import { connect } from 'react-redux';
import { sendAdobePostMessage } from '../../../../helpers/Adobe';
import { isMiniAdobeIntegration } from '../../../../helpers/App';

const FileMiniActionsSuperAction = ({
  file,
  openedFiles,
  fileLocked,
  activeFile,
}) => {
  const fileOpened = openedFiles.find(o => o.uuid === file.uuid);

  if (!fileOpened) {
    return null;
  }

  return (
    <li>
      <a
        id={`file-${file.uuid}-file-open-superaction`}
        href={`#file-${file.uuid}-file-open-superaction`}
        className="file-opened-superaction"
        onClick={(e) => {
          e.preventDefault();
          if (!fileLocked) {
            if (isMiniAdobeIntegration()) {
              sendAdobePostMessage('switch-to-document', { id: fileOpened.id });
            }
          }
        }}
      >
        <img
          src="/images/stockpress-brand-mark.png"
          alt="Stockpress"
          className="integration-save-logo"
        />
        <span>
          Opened
        </span>
      </a>
      {(activeFile && activeFile !== file.uuid) && (
        <UncontrolledTooltip fade={false} target={`file-${file.uuid}-file-open-superaction`}>
          Switch to file
        </UncontrolledTooltip>
      )}
    </li>
  );
};

const mapStateToProps = state => ({
  openedFiles: state.Mini.openedFiles,
  activeFile: state.Mini.activeFile,
});

FileMiniActionsSuperAction.propTypes = {
  file: PropTypes.object.isRequired,
  fileLocked: PropTypes.bool.isRequired,
  openedFiles: PropTypes.array.isRequired,
  activeFile: PropTypes.string,
};

FileMiniActionsSuperAction.defaultProps = {
  activeFile: null,
};

export default connect(mapStateToProps)(FileMiniActionsSuperAction);
